import { render } from "./Breadcrumbs.vue?vue&type=template&id=5bf93ca9"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js"

import "./Breadcrumbs.vue?vue&type=style&index=0&id=5bf93ca9&lang=css"

import exportComponent from "G:\\workspace\\screened-cv-parser\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__